// KITE — abstraction framework for digital & AI orchestration.
export default function KiteDiagram() {
  const cx = 300;
  const cy = 300;
  const top = { x: 300, y: 70 };
  const left = { x: 80, y: 300 };
  const right = { x: 520, y: 300 };
  const bottom = { x: 300, y: 530 };

  const Vertex = ({ p, label, sub, color }) => (
    <g>
      <circle cx={p.x} cy={p.y} r="9" fill={color} />
      <text
        x={p.x}
        y={p.y === top.y ? p.y - 18 : p.y === bottom.y ? p.y + 30 : p.y - 16}
        textAnchor="middle"
        fontFamily="'Space Grotesk', sans-serif"
        fontSize="20"
        fontWeight="600"
        fill="#E8ECF6"
      >
        {label}
      </text>
      {sub && (
        <text
          x={p.x}
          y={p.y === top.y ? p.y - 2 : p.y + 48}
          textAnchor="middle"
          fontFamily="'IBM Plex Mono', monospace"
          fontSize="10"
          letterSpacing="1.5"
          fill="#8C97B5"
        >
          {sub}
        </text>
      )}
    </g>
  );

  return (
    <svg viewBox="0 0 600 600" className="w-full h-auto" role="img"
      aria-label="The KITE framework: a diamond with AI at the top, Organisation on the left, Society on the right, and Sustainability at the bottom. The vertical axis (AI to Sustainability) is AI for Good; the horizontal axis (Organisation to Society) is People and Culture. Edges are labelled AI Strategy, DEI for Social Justice in AI, Governance and Responsibility, and the UN 17 SDGs.">
      <defs>
        <linearGradient id="kiteGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#46E0D0" />
          <stop offset="100%" stopColor="#8B7CFF" />
        </linearGradient>
      </defs>

      {/* diamond edges */}
      <polygon
        points={`${top.x},${top.y} ${right.x},${right.y} ${bottom.x},${bottom.y} ${left.x},${left.y}`}
        fill="rgba(70,224,208,0.04)"
        stroke="url(#kiteGrad)"
        strokeWidth="2"
      />

      {/* axes */}
      <line x1={top.x} y1={top.y} x2={bottom.x} y2={bottom.y} stroke="#46E0D0" strokeWidth="1.5" strokeDasharray="4 5" opacity="0.7" />
      <line x1={left.x} y1={left.y} x2={right.x} y2={right.y} stroke="#8B7CFF" strokeWidth="1.5" strokeDasharray="4 5" opacity="0.7" />

      {/* axis labels */}
      <text x={cx + 8} y={cy - 70} fontFamily="'IBM Plex Mono', monospace" fontSize="11" letterSpacing="1" fill="#46E0D0" textAnchor="start">AI for Good</text>
      <text x={cx} y={cy - 12} fontFamily="'IBM Plex Mono', monospace" fontSize="11" letterSpacing="1" fill="#8B7CFF" textAnchor="middle">People &amp; Culture</text>

      {/* edge labels */}
      <text x="165" y="170" fontFamily="'IBM Plex Sans', sans-serif" fontSize="12" fill="#8C97B5" textAnchor="middle">AI Strategy</text>
      <text x="435" y="170" fontFamily="'IBM Plex Sans', sans-serif" fontSize="12" fill="#8C97B5" textAnchor="middle">DEI for Social Justice</text>
      <text x="158" y="445" fontFamily="'IBM Plex Sans', sans-serif" fontSize="12" fill="#8C97B5" textAnchor="middle">Governance &amp; Responsibility</text>
      <text x="442" y="445" fontFamily="'IBM Plex Sans', sans-serif" fontSize="12" fill="#8C97B5" textAnchor="middle">UN 17 SDGs</text>

      {/* central core */}
      <circle cx={cx} cy={cy} r="6" fill="url(#kiteGrad)" />

      <Vertex p={top} label="AI" color="#46E0D0" />
      <Vertex p={left} label="Organisation" color="#8B7CFF" />
      <Vertex p={right} label="Society" color="#8B7CFF" />
      <Vertex p={bottom} label="Sustainability" color="#46E0D0" />
    </svg>
  );
}
